import * as yup from 'yup';

export const schema = yup.object().shape({
  isMobileNumberConfirmed: yup
    .boolean()
    .nullable()
    .required('Please confirm if the mobile number displayed is your current mobile number.')
});
